import { Box, Grid, Text, Textarea } from "@chakra-ui/react";
import SharedSelect from "../../../../../../shared/components/Select";
import { entityProfileModalColors } from "../../../../../entityProfileModal/entityProfileModal.theme";
import type { PatientProfilePatient } from "../../../../patientProfileModal.types";
import type { PatientAllergy, PatientFieldsDraft } from "../staffingPreferences.types";
import { getAllergiesLabel } from "../staffingPreferences.utils";

export function PatientClinicalFields(props: {
  allergyOptions: Array<{ value: PatientAllergy["id"]; label: string }>;
  isEditing: boolean;
  isLoadingAllergies: boolean;
  patient: PatientProfilePatient;
  patientFieldsDraft: PatientFieldsDraft;
  onChangePatientFieldsDraft: (draft: PatientFieldsDraft) => void;
  onCommitAllergies: (nextAllergyIds: Array<PatientAllergy["id"]> | undefined) => void;
  onCommitMedicalNotes: (medicalNotes: string) => void;
}) {
  return (
    <Grid gap={8} templateColumns={{ base: "1fr", lg: "repeat(2, minmax(0, 1fr))" }}>
      <Box>
        <Text color={entityProfileModalColors.text} fontSize="24px" fontWeight={300} mb={2}>
          Allergies:
        </Text>
        {props.isEditing ? (
          <Box maxW="320px">
            <SharedSelect
              isLoading={props.isLoadingAllergies}
              label="Select allergies"
              multiple={true}
              options={props.allergyOptions}
              searchable={true}
              selectedLabel={(value) =>
                value.length === 0 ? "Select allergies" : `Allergies (${value.length})`
              }
              value={props.patientFieldsDraft.allergyIds}
              onChange={props.onCommitAllergies}
            />
          </Box>
        ) : (
          <Text color={entityProfileModalColors.text} fontSize="14px">
            {getAllergiesLabel(props.patient.allergies)}
          </Text>
        )}
      </Box>

      <Box>
        <Text color={entityProfileModalColors.text} fontSize="24px" fontWeight={300} mb={2}>
          Medical Notes:
        </Text>
        {props.isEditing ? (
          <>
            <Text color={entityProfileModalColors.danger} fontSize="13px" mb={2}>
              ** Use this section to describe the patient information. This section will be only
              visible to the skilled / Non - Skilled assigned to work with the patient **
            </Text>
            <Textarea
              rows={5}
              value={props.patientFieldsDraft.medicalNotes}
              onBlur={(event) => props.onCommitMedicalNotes(event.currentTarget.value)}
              onChange={(event) =>
                props.onChangePatientFieldsDraft({
                  ...props.patientFieldsDraft,
                  medicalNotes: event.target.value,
                })
              }
            />
          </>
        ) : (
          <Text color={entityProfileModalColors.text} fontSize="14px" whiteSpace="pre-wrap">
            {props.patient.medicalNotes ?? ""}
          </Text>
        )}
      </Box>
    </Grid>
  );
}
